import * as parentConstants from 'modules/client-admin/ClientsPage/constants';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import Page from 'modules/Page';
import * as constants from './constants';

const NewClientPage = lazyWithSuspense(() => import('./NewClientPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage({
    WrappedPage: NewClientPage,
    titleFn: () => i18n._(constants.TITLE),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
  }),
};

export default page;
